import React, { useEffect, useState } from "react";
import {
    Box,
} from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebMultipleSelectionOption({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [answerBox, setAnswerBox] = useState(data.answerBox);
    const [answer, setAnswer] = useState(data.initialState);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAnswerBox(data.answerBox);
        setAnswer(data.initialState)
    }, [question,
        data.answerBox,
        data.initialState,
    ])

    const handleChoiceClick = (key, index) => {
        let ans = [...answer];
        ans[index] = key;
        setAnswer(ans);

        const canProceed = ans.length > 0;
        onAnswer({
            canProceed,
            answer: ans,
        });
    }

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "1000px",
            textAlign: "center",
        }}>
            <Box component="img" src={`${imagesResources}${data?.image}`}
                style={{
                    width: "100%",
                    marginBottom: "10px",
                    textAlign: "center",
                }}
                alt="Img"
            />
            {answerBox.map((ans, index) => (
                <React.Fragment key={index}>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        fontWeight: "bold",
                        justifyContent: "space-between",
                        padding: "5px",
                        backgroundColor: "rgb(255, 192, 0)",
                        borderBottom: '5px solid rgb(185, 138, 23)',
                        marginBottom: "5px",
                        alignItems: "center",
                        textAlign: "center",
                        fontSize: "18px",
                    }}>
                        {ans.value}
                        <Box sx={{
                            display: "flex",
                            fontWeight: "bold",
                            textAlign: "center",
                        }}>
                            {ans.options.map((option, optionIndex) => (
                                <Box key={optionIndex}
                                    component="span"
                                    sx={{
                                        width: "100px",
                                        height: "30px",
                                        marginLeft: "10px",
                                        display: "inline-table",
                                        cursor: "pointer",
                                        userSelect: "none",
                                        backgroundColor: answer[index] === option.stateKey ? "#afe23e" : "#dadada",
                                        borderBottom: answer[index] === option.stateKey ? "10px solid #639729" : "10px solid #808080",
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    }}
                                    onClick={() => handleChoiceClick(option.stateKey, index)}
                                >
                                    <Box component="span"
                                        style={{
                                            display: "table-cell",
                                            verticalAlign: "center",
                                            cursor: "pointer",
                                            fontWeight: "bold",
                                        }}
                                    >{option.value}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </React.Fragment>
            ))}
        </Box>
    );
};